import { render, staticRenderFns } from "./allout.vue?vue&type=template&id=52b85fbc&"
import script from "./allout.vue?vue&type=script&lang=js&"
export * from "./allout.vue?vue&type=script&lang=js&"
import style0 from "./allout.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports